module.exports = __webpack_public_path__ + "media/bootstrap-icons/skip-backward-fill-76abf5e0.svg";